import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { VerificationStatusSpecs } from '@/data/customerVerificationStatuses';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly specs: VerificationStatusSpecs;
}

export const VerificationBadge: React.FC<Props> = (props: Props): React.ReactElement => {
  const { specs } = props;
  const tr = useTranslator();

  return (
    <Box
      sx={{
        ...styles.badge,
        backgroundColor: specs.backgroundColor,
      }}>
      <Typography variant="body1" color={specs.color}>
        {tr(specs.label)}
      </Typography>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: 1.5,
    py: 0.5,
    borderRadius: 2,
  },
};
